import { Component, OnInit, OnDestroy } from '@angular/core';
import { HomeService } from '../services/home.service';
import { Location } from '@angular/common';
import { Subject, takeUntil, finalize } from 'rxjs';

@Component({
  selector: 'app-kyc-details',
  templateUrl: './kyc-details.component.html',
  styleUrls: ['./kyc-details.component.scss']
})
export class KycDetailsComponent implements OnInit, OnDestroy {
  userKycDetails: any = null;
  loading: boolean = false;
  error: string | null = null;
  
  private destroy$ = new Subject<void>();

  constructor(
    private home: HomeService, 
    private location: Location
  ) { }

  ngOnInit(): void {
    this.kycGet();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack() {
    this.location.back();
  }

  // kycGet(): void {
  //   this.loading = true;
  //   this.error = null;
    
  //   this.home.getUserKyc()
  //     .pipe(
  //       takeUntil(this.destroy$),
  //       finalize(() => this.loading = false)
  //     )
  //     .subscribe({
  //       next: (res: any) => {
  //         console.log('KYC API Response:', res);
          
  //         // Handle the response structure
  //         if (res) {
  //           this.userKycDetails = res;
            
  //         } else {
  //           this.userKycDetails = null;
  //         }
  //       },
  //       error: (err) => {
  //         console.error('Error fetching KYC dataAAAAAAAAAAAAAA', err);
          
  //         // More detailed error message
  //         if (err.status === 400) {
  //           this.error = 'Bad request. Please check your authentication.';
  //         } else if (err.status === 401) {
  //           this.error = 'Unauthorized. Please login again.';
  //         } else if (err.status === 404) {
  //           this.error = 'KYC details not found.';
  //         } else {
  //           this.error = err.error?.message || err.message || 'Failed to load KYC details';
  //         }
          
  //         this.userKycDetails = null;
  //       }
  //     });
  // }

showUpdateLink: boolean = false;
  kycGet(): void {
  this.loading = true;
  this.error = null;

  this.home.getUserKyc()
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => this.loading = false)
    )
    .subscribe({
      next: (res: any) => {
        console.log('KYC API Response:', res);

        if (res) {
          this.userKycDetails = res;

          // Show update link only when statuscode is 3
          this.showUpdateLink = res.statusCode === 3;
        } else {
          this.userKycDetails = null;
          this.showUpdateLink = false;
        }
      },
      error: (err) => {
        console.error('Error fetching KYC data', err);

        this.showUpdateLink = false;

        if (err.status === 400) {
          this.error = 'Bad request. Please check your authentication.';
        } else if (err.status === 401) {
          this.error = 'Unauthorized. Please login again.';
        } else if (err.status === 404) {
          this.error = 'KYC details not found.';
        } else {
          this.error = err.error?.message || err.message || 'Failed to load KYC details';
        }

        this.userKycDetails = null;
      }
    });
}
  // Helper method to safely get values
  getValue(path: string): string {
    if (!this.userKycDetails) return 'N/A';
    
    const parts = path.split('.');
    let value = this.userKycDetails;
    
    for (const part of parts) {
      if (value === null || value === undefined) return 'N/A';
      value = value[part];
    }
    
    return value !== null && value !== undefined ? String(value) : 'N/A';
  }

  // Get status message
  getStatusMessage(): string {
    const msg = this.userKycDetails?.msg || this.userKycDetails?.message;
    if (msg) return msg;
    
    const statusCode = this.userKycDetails?.statusCode || this.userKycDetails?.data?.kyc_status;
    
    switch(statusCode) {
      case 0: return 'KYC Pending';
      case 1: return 'Waiting for KYC Approval';
      case 2: return 'KYC Approved';
      case 3: return 'KYC Rejected';
      default: return 'KYC Status Unknown';
    }
  }

  // Check if should show update link
  // get showUpdateLink(): boolean {
  //   const statusCode = this.userKycDetails?.statusCode || this.userKycDetails?.data?.kyc_status;
  //   return statusCode !== 3; // Show if not approved
  // }

  getStatusClass(): string {
  const status = this.getStatusMessage()?.toLowerCase() || '';
  if (status.includes('approved')) return 'status-approved';
  if (status.includes('reject')) return 'status-rejected';
  return 'status-pending';
}
}